'use client';

import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

import { VisibleSearchBar } from '@/components/VisibleSearchBar';
import { useProductsSearchBar } from '@/modules/product/hooks/useProductsSearchBar';
import { useOnScrollUp } from '@/utils/useOnScrollUp';

export function ProductSearchBar() {
  const { isVisible, isSticky } = useProductsSearchBar();
  const { hasScrolledUp } = useOnScrollUp();

  const searchBarIsSticky = isSticky && hasScrolledUp;

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <VisibleSearchBar
        className={clsx(styles.container, {
          [styles.stickyMobileSearchBar]: searchBarIsSticky,
        })}
      />
      {!searchBarIsSticky && <div className={styles.fixedBorderBottom} />}
      {searchBarIsSticky && <div className={styles.placeholder} />}
    </>
  );
}
